const baseURL = 'https://miturno.grupoinformaticofc.com/';

export default baseURL;
